import { NavigationService, StringService } from '../../services';
import { Link } from '../../services/navigation/types';

export const multiLink = (key: string, data: Link): Record<string, string> => ({
  [StringService.snakeToKebab(key)]: NavigationService.getParsedMultiLink(data),
});
